var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("Erreur 404: page non trouvée")]),_c('b-button',{attrs:{"to":"/","variant":"primary"}},[_vm._v("Retour accueil")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }